<template>
    <LayoutWrapper :id="id">
        <LayoutPaddingSpace>
            <LayoutContainer>
                <LayoutColumn>
                    <SectionTitle>
                        {{ $t('Search.labels.searchParameters') }}
                    </SectionTitle>
                    <SectionBlock>
                        <SubjectLengthField />
                        <AlignmentIdentityField />
                        <QueryIdentityField />
                        <QueryCoverageField />
                        <SubjectIdentityField />
                        <SubjectCoverageField />
                        <MaxTargetSequenceField />
                    </SectionBlock>
                </LayoutColumn>
                <LayoutColumn>
                    <SectionTitle>
                        {{ $t('Search.labels.algorithmSettings') }}
                    </SectionTitle>
                    <div>
                        <SectionBlock>
                            <MatchWithGapsField />
                            <EvalueField />
                            <LowComplexRegionField />
                        </SectionBlock>
                    </div>
                </LayoutColumn>
            </LayoutContainer>
        </LayoutPaddingSpace>
        <ResetSection />
    </LayoutWrapper>
</template>

<script>
import BioSearchSettingProvider from '../BioSearchSettingProvider.vue';

export default {
    extends: BioSearchSettingProvider,
};
</script>
